import slice from "./partnerFiltersSlice";

export default slice.reducer;
